import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { vazirFont } from './pdfFonts';

export const generateWorkoutPdf = (planData) => {
  // planData = { warmup: [...], days: [...] }

  const doc = new jsPDF('p', 'mm', 'a4');

  // فونت فارسی
  doc.addFileToVFS('Vazir.ttf', vazirFont);
  doc.addFont('Vazir.ttf', 'Vazir', 'normal');
  doc.setFont('Vazir');
  doc.setFontSize(12);

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  let currentY = 20;

  // helper: چک کن جا مونده یا نه، اگه نه برو صفحه بعد
  const ensureSpace = (needed = 20) => {
    if (currentY + needed > pageHeight - 20) {
      doc.addPage();
      doc.setFont('Vazir');
      doc.setFontSize(12);
      currentY = 20;
    }
  };

  // ---------------------------
  // سکشن گرم کردن
  // ---------------------------
  if (planData.warmup && Array.isArray(planData.warmup) && planData.warmup.length > 0) {
    // تیتر گرم کردن
    doc.setFontSize(14);
    doc.setTextColor(220, 120, 0); // نارنجی ملایم
    doc.text('حرکات گرم کردن (قبل از شروع هر روز)', pageWidth - 10, currentY, {
      align: 'right'
    });

    currentY += 8;
    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0);
    doc.text(
      '.این حرکات رو قبل از هر جلسه تمرین انجام بده',
      pageWidth - 10,
      currentY,
      { align: 'right' }
    );

    currentY += 6;

    // جدول گرم کردن
    const warmupRows = planData.warmup
      .slice()
      .sort((a, b) => {
        const A = parseInt(a.Order, 10);
        const B = parseInt(b.Order, 10);
        if (isNaN(A) || isNaN(B)) return 0;
        return A - B;
      })
      .map((w) => [
        w.SetOrDuration || '',
        w.Name || ''
      ]);

    autoTable(doc, {
      startY: currentY,
      head: [[
        '\u0645\u062F\u062A / \u0633\u062A', // مدت / ست
        '\u0646\u0627\u0645 \u062D\u0631\u06A9\u062A' // نام حرکت
      ]],
      body: warmupRows,
      styles: {
        font: 'Vazir',
        fontSize: 10,
        halign: 'right',
      },
      headStyles: {
        font: 'Vazir',
        fontStyle: 'normal',
        fontSize: 11,
        halign: 'right',
        textDirection: 'rtl',
        fillColor: [255, 140, 70],
        textColor: 255,
      },
      columnStyles: {
        0: { cellWidth: 50 }, // مدت / ست
        1: { cellWidth: 120 }, // نام حرکت
      },
      margin: { right: 10, left: 10 },
      didDrawPage: (data) => {
        // واترمارک وسط صفحه
        doc.setFontSize(50);
        doc.setTextColor(150);
        doc.text(
          'mogym.ir',
          pageWidth / 2,
          pageHeight / 2,
          {
            align: 'center',
            angle: 45,
          }
        );

        // ریست برای ادامه
        doc.setFont('Vazir');
        doc.setFontSize(10);
        doc.setTextColor(0);

        currentY = data.cursor.y + 10;
      }
    });

    currentY += 4;
    ensureSpace(30);
  }

  // ---------------------------
  // روزهای تمرینی
  // ---------------------------
  const daysArray = planData.days || [];

  daysArray.forEach((day, dayIdx) => {
    // قبل از شروع هر روز جدید مطمئن شو جا داریم
    ensureSpace(30);

    // تیتر روز و عضله هدف
    doc.setFontSize(13);
    doc.setTextColor(0, 0, 0);
    doc.text(
      `روز: ${day.DayOfWeek || ''} | عضله: ${day.MuscleGroup || ''}`,
      pageWidth - 10,
      currentY,
      { align: 'right' }
    );
    currentY += 8;

    // برای هر گروه تمرینی جدول جدا
    ;(day.WorkoutGroups || []).forEach((group) => {
      const rows = (group.ExerciseRecords || []).map((ex) => [
        ex.Description || '',
        (ex.RestSeconds !== undefined && ex.RestSeconds !== null)
          ? `${ex.RestSeconds} ثانیه`
          : '',
        `${ex.Sets || ''} × ${ex.Reps || ''}`,
        ex.Name || ''
      ]);

      autoTable(doc, {
        startY: currentY,
        head: [[
          '\u062A\u0648\u0636\u06CC\u062D\u0627\u062A', // توضیحات
          '\u0627\u0633\u062A\u0631\u0627\u062D\u062A', // استراحت
          '\u062A\u0639\u062F\u0627\u062F',             // تعداد
          '\u0646\u0627\u0645 \u062D\u0631\u06A9\u062A' // نام حرکت
        ]],
        body: rows,
        styles: {
          font: 'Vazir',
          fontSize: 10,
          halign: 'right',
        },
        headStyles: {
          font: 'Vazir',
          fontStyle: 'normal',
          fontSize: 11,
          halign: 'right',
          textDirection: 'rtl',
          fillColor: [90, 60, 60],
          textColor: 255,
        },
        columnStyles: {
          0: { cellWidth: 67.5 }, // توضیحات
          1: { cellWidth: 37.5 }, // استراحت
          2: { cellWidth: 42.5 }, // تعداد
          3: { cellWidth: 47.5 }, // نام حرکت
        },
        margin: { right: 10, left: 10 },
        didDrawPage: (data) => {
          // واترمارک
          doc.setFontSize(50);
          doc.setTextColor(150);
          doc.text(
            'mogym.ir',
            pageWidth / 2,
            pageHeight / 2,
            {
              align: 'center',
              angle: 45,
            }
          );

          // ریست بعد از جدول
          doc.setFont('Vazir');
          doc.setFontSize(10);
          doc.setTextColor(0);

          currentY = data.cursor.y + 10;
        },
      });

      currentY += 4;
      ensureSpace(20);
    });

    currentY += 6;
  });

  doc.save('mogym_workout_plan.pdf');
};
